<template>
  <div class="px-8">
    <v-card class="pb-3 mb-10 rounded-10 elevation-card mt-4">
      <v-card-title>
        <span
          class="font-weight-700 fs-20 lh-16 pl-1 bluedarken--text text-uppercase"
          style="align-self: center"
        >
          {{ tab === 'all' ? 'SN Indonesia' : tab }}
        </span>
        <v-spacer></v-spacer>
        <v-icon
          color="bluedarken"
          style="font-size: 22px !important"
          id="refreshBudget"
          @click="refresh"
        >
          refresh
        </v-icon>
      </v-card-title>
      <v-card-text class="px-3 py-2">
        <v-row xs12 class="px-2 pl-5">
          <span class="font-weight-bold fs-14 align-self-center">
            YTD
          </span>
          <span class="pl-3 font-weight-bold fs-14 align-self-center">
            :
            {{
              itemsTable.length !== 0
                ? formatMonthYear(itemsTable[0].monthly_report)
                : '-'
            }}
          </span>
          <v-spacer></v-spacer>
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="btn-column"
                class="primary--text pb-0 mr-3"
                depressed
                color="lightblue"
                v-bind="attrs"
                v-on="on"
              >
                Select Column
              </v-btn>
            </template>
            <v-list-item-group
              v-model="columnActive"
              multiple
              class="menuColumn"
            >
              <div
                class="px-4 py-2"
                @click="selectAllColumn()"
                style="cursor:pointer;"
              >
                <v-row>
                  <v-flex xs2 class="ml-4" style="max-width: 37px !important;">
                    <v-icon v-if="isSelectedAll" color="primary accent-4">
                      check_box
                    </v-icon>
                    <v-icon color="primary accent-4" v-else>
                      check_box_outline_blank
                    </v-icon>
                  </v-flex>
                  <v-flex xs8 class="pt-1">
                    <v-list-item-title class="text-left">
                      Select All
                    </v-list-item-title>
                  </v-flex>
                </v-row>
              </div>
              <template v-for="(item, i) in columnTable">
                <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>
                <v-list-item
                  v-else
                  :key="`item-${i}`"
                  :value="item"
                  class="text-left"
                  style="max-height: 48px !important;"
                  active-class="primary--text text--accent-4"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content style="max-width: 20px !important;">
                    </v-list-item-content>

                    <v-list-item-action style="width: 100%">
                      <v-flex xs12>
                        <v-row>
                          <v-flex xs2 class="pt-1">
                            <v-icon color="primary accent-4" v-if="active">
                              check_box
                            </v-icon>
                            <v-icon v-else color="primary accent-4">
                              check_box_outline_blank
                            </v-icon>
                          </v-flex>
                          <v-flex xs8 class="pt-1">
                            <v-list-item-title class="text-left" v-text="item">
                            </v-list-item-title>
                          </v-flex>
                        </v-row>
                      </v-flex>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-menu>
        </v-row>
        <v-col sm="12" class="px-2">
          <v-simple-table fixed-header class="table-taxonomy nav-table mt-1">
            <template v-slot:default>
              <v-perfect-scroll
                class="drawer-menu--scroll-consolidatePO"
                :settings="scrollSettings"
              >
                <thead>
                  <tr>
                    <th
                      v-if="checkColspan() !== 0"
                      :colspan="checkColspan()"
                      class="rounded-7 white--text"
                      style="border: 2px solid #fff !important; border-left: 0; border-right: 0;"
                    >
                      Promo/IO
                    </th>
                    <!-- <th
                      rowspan="2"
                      class="white--text rounded-top-left-7 rounded-top-right-7"
                      style="border: 2px solid #fff !important; border-bottom: 0"
                    >
                      Amount
                    </th> -->
                    <!-- <th
                      colspan="10"
                      class="rounded-7 white--text"
                      style="border: 2px solid #fff !important; border-left: 0"
                    >
                      IO MOVEMENT
                    </th> -->
                    <!-- <th
                      rowspan="2"
                      class="white--text rounded-top-left-7 rounded-top-right-7"
                      style="border: 2px solid #fff !important; border-bottom: 0"
                    >
                      Total Amount
                    </th> -->
                    <!-- <th
                      colspan="5"
                      class="rounded-7 white--text"
                      style="border: 2px solid #fff !important; border-left: 0"
                    >
                      TOPLINE SPENDING
                    </th>
                    <th
                      rowspan="2"
                      class="white--text rounded-top-left-7 rounded-top-right-7"
                      style="border: 2px solid #fff !important; border-bottom: 0"
                    >
                      Remaining IO
                    </th> -->
                    <th
                      v-if="checkColspan2() !== 0"
                      :colspan="checkColspan2()"
                      class="rounded-7 white--text"
                      style="border: 2px solid #fff !important;"
                    >
                      AR1 Actual Landing
                    </th>
                    <!-- <th
                      rowspan="2"
                      class="white--text rounded-top-left-7 rounded-top-right-7"
                      style="border: 2px solid #fff !important; border-bottom: 0"
                    >
                      Aging
                    </th>
                    <th
                      colspan="9"
                      class="white--text rounded-top-left-7 rounded-top-right-7"
                      style="border-bottom: 2px solid #fff !important;"
                    ></th> -->
                  </tr>
                  <tr>
                    <!-- <th class="f-14 white--text sticky-header1_"> -->
                    <th
                      v-if="columnActive.includes('Department')"
                      class="f-14 white--text top-37"
                    >
                      Department
                      <filter-column
                        field="dept"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('dept')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <!-- <th class="f-14 white--text sticky-header2-monthly"> -->
                    <!-- <th class="f-14 white--text">
                      Internal Order
                    </th> -->
                    <th
                      v-if="columnActive.includes('IO Description')"
                      class="f-14 white--text top-37"
                    >
                      IO Description
                      <filter-column
                        field="io_description"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('io_description')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <!-- <th class="f-14 white--text">
                      IO Creation Date
                    </th>
                    <th class="f-14 white--text">
                      Start
                    </th>
                    <th class="f-14 white--text">
                      End
                    </th> -->
                    <th
                      v-if="columnActive.includes('Entity')"
                      class="f-14 white--text top-37"
                    >
                      Entity
                      <filter-column
                        field="entity_name"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('entity_name')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Brand/Division')"
                      class="f-14 white--text top-37"
                    >
                      Brand/Division
                      <filter-column
                        field="brand_division"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('brand_division')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <!-- <th class="f-14 white--text">
                      Applicant
                    </th>
                    <th class="f-14 white--text">
                      Cost Center Description
                    </th>
                    <th class="f-14 white--text">
                      Cost Center
                    </th>
                    <th class="f-14 white--text">
                      Cost Element Group
                    </th> -->
                    <th
                      v-if="columnActive.includes('GL Account')"
                      class="f-14 white--text top-37"
                    >
                      GL Account
                      <filter-column
                        field="cost_element.code"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('cost_element.code')"
                        @filterItem="searchCln"
                        :isCode="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('GL Account Description')"
                      class="f-14 white--text top-37"
                    >
                      GL Account Description
                      <filter-column
                        field="cost_element.desc"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('cost_element.desc')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <!-- <th class="f-14 white--text">
                      Material Group
                    </th>
                    <th class="f-14 white--text">
                      Product Hierarchy
                    </th>
                    <th class="f-14 white--text">
                      Product Hierarchy Description
                    </th>
                    <th class="f-14 white--text">
                      BPC Line
                    </th>
                    <th class="f-14 white--text">
                      Additional 1
                    </th>
                    <th class="f-14 white--text">
                      Additional 2
                    </th>
                    <th class="f-14 white--text">
                      Additional 3
                    </th>
                    <th class="f-14 white--text">
                      Additional 4
                    </th>
                    <th class="f-14 white--text">
                      Additional 5
                    </th>
                    <th class="f-14 white--text">
                      Additional 6
                    </th>
                    <th class="f-14 white--text">
                      Reallocation
                    </th>
                    <th class="f-14 white--text">
                      CloseIO (-)
                    </th>
                    <th class="f-14 white--text">
                      Protein (-)
                    </th>
                    <th class="f-14 white--text">
                      A&P Cut (-)
                    </th>
                    <th class="f-14 white--text">
                      IO YTD
                    </th> -->
                    <!-- <th class="f-14 white--text">
                      Actual
                    </th>
                    <th class="f-14 white--text">
                      Commitement PO
                    </th>
                    <th class="f-14 white--text">
                      Pull Forward
                    </th>
                    <th class="f-14 white--text">
                      Total Spending
                    </th> -->
                    <th
                      v-if="columnActive.includes('Actual')"
                      class="f-14 white--text top-37"
                    >
                      Actual
                      <filter-column
                        field="ar1_actual"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('ar1_actual')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Accrual')"
                      class="f-14 white--text top-37"
                    >
                      Accrual
                      <filter-column
                        field="ar1_commitment_po"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('ar1_commitment_po')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <!-- <th class="f-14 white--text">
                      Commitment Manual
                    </th>
                    <th class="f-14 white--text">
                      GRIR
                    </th>
                    <th class="f-14 white--text">
                      Realization 2019
                    </th>
                    <th class="f-14 white--text">
                      Reverse 2019
                    </th> -->
                    <th
                      v-if="columnActive.includes('YTD Landing')"
                      class="f-14 white--text top-37"
                    >
                      YTD Landing
                      <filter-column
                        field="ar1_total_spending"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('ar1_total_spending')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <!-- <th class="f-14 white--text">
                      House
                    </th>
                    <th class="f-14 white--text">
                      A&P Code
                    </th>
                    <th class="f-14 white--text">
                      IO Amount
                    </th> -->
                    <!-- <th class="f-14 white--text">
                      IO YTD
                    </th>
                    <th class="f-14 white--text">
                      PO
                    </th>
                    <th class="f-14 white--text">
                      GR & Non PO Act
                    </th>
                    <th class="f-14 white--text">
                      PO YTD
                    </th>
                    <th class="f-14 white--text">
                      GR & Non PO Act ADJ
                    </th>
                    <th class="f-14 white--text">
                      Commitment PO
                    </th> -->
                  </tr>
                </thead>
                <tbody v-if="itemsTamp.length > 0">
                  <tr
                    v-for="(val, index) in itemsTamp"
                    :key="'entitiesdata' + index"
                  >
                    <!-- <td class="sticky-body1_"> -->
                    <td v-if="columnActive.includes('Department')">
                      <v-edit-dialog
                        :return-value.sync="val.dept"
                        large
                        @save="savePO(val, 'dept')"
                        @cancel="cancelPO(val, 'dept')"
                      >
                        {{ val.dept }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'dept')"
                            :value="val.dept"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <!-- <td>7024661</td> -->
                    <td v-if="columnActive.includes('IO Description')">
                      {{ val.io_description || '-' }}
                    </td>
                    <!-- <td>12/3/2019</td>
                    <td>1/1/2020</td>
                    <td>12/31/2020</td> -->
                    <td v-if="columnActive.includes('Entity')">
                      <v-edit-dialog
                        :return-value.sync="val.entity_name"
                        large
                        @save="savePO(val, 'entity_name')"
                        @cancel="cancelPO(val, 'entity_name')"
                      >
                        {{ val.entity_name }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'entity_name')"
                            :value="val.entity_name"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Brand/Division')">
                      <v-edit-dialog
                        :return-value.sync="val.brand_division"
                        large
                        @save="savePO(val, 'brand_division')"
                        @cancel="cancelPO(val, 'brand_division')"
                      >
                        {{ val.brand_division }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'brand_division')"
                            :value="val.brand_division"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <!-- <td>2020</td>
                    <td>Continuing Medical Education</td>
                    <td>400127</td>
                    <td>B210</td> -->
                    <td v-if="columnActive.includes('GL Account')">
                      <v-edit-dialog
                        :return-value.sync="val.cost_element.code"
                        large
                        @save="savePO(val, 'cost_element')"
                        @cancel="cancelPO(val, 'cost_element')"
                      >
                        {{ val.cost_element.code }}
                        <template v-slot:input>
                          <v-autocomplete
                            id="code-group"
                            single-line
                            placeholder="Select Cost Element"
                            :value="val.cost_element"
                            required
                            class="mt-1"
                            :items="costElements"
                            return-object
                            @input="editItem($event, 'cost_element')"
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.code }} - {{ data.item.desc }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.code }} - {{ data.item.desc }}
                            </template>
                          </v-autocomplete>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('GL Account Description')">
                      {{ val.cost_element ? val.cost_element.desc : '-' }}
                    </td>
                    <!-- <td>X020102</td>
                    <td>83627223813</td>
                    <td>SGM IFFO</td>
                    <td>Consumer Communications</td> -->
                    <td
                      class="text-right"
                      v-if="columnActive.includes('Actual')"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.ar1_actual"
                        large
                        @save="savePO(val, 'ar1_actual')"
                        @cancel="cancelPO(val, 'ar1_actual')"
                      >
                        {{ idr(val.ar1_actual) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'ar1_actual')"
                            :value="val.ar1_actual"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      class="text-right"
                      v-if="columnActive.includes('Accrual')"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.ar1_commitment_po"
                        large
                        @save="savePO(val, 'ar1_commitment_po')"
                        @cancel="cancelPO(val, 'ar1_commitment_po')"
                      >
                        {{ idr(val.ar1_commitment_po) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'ar1_commitment_po')"
                            :value="val.ar1_commitment_po"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      class="text-right"
                      v-if="columnActive.includes('YTD Landing')"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.ar1_total_spending"
                        large
                        @save="savePO(val, 'ar1_total_spending')"
                        @cancel="cancelPO(val, 'ar1_total_spending')"
                      >
                        {{ idr(val.ar1_total_spending) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'ar1_total_spending')"
                            :value="val.ar1_total_spending"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                  <tr class="bgTotal font-weight-bold text-right">
                    <td
                      :colspan="colspanTotal"
                      class="border-r-0 font-weight-bold sticky-amount"
                    >
                      Total
                    </td>
                    <td
                      v-if="columnActive.includes('Actual')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('ar1_actual', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('Accrual')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('ar1_commitment_po', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('YTD Landing')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('ar1_total_spending', itemsTamp) }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="9" class="text-center">
                      No data displayed
                    </td>
                  </tr>
                </tbody>
              </v-perfect-scroll>
            </template>
          </v-simple-table>
        </v-col>
      </v-card-text>
    </v-card>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import filterColumn from '../filterColumn';
import ProgressDialog from '../progress_dialog';

export default {
  props: {
    itemsTable: {
      type: Array,
      required: true
    },
    tab: {
      type: String,
      required: true
    }
  },
  components: {
    'filter-column': filterColumn,
    'progress-dialog': ProgressDialog
  },
  data() {
    return {
      progressDialogLoading: false,
      scrollSettings: {
        maxScrollbarLength: 60
      },
      costElements: [],
      itemsTamp: [],
      columnTable: [
        'Department',
        'IO Description',
        'Entity',
        'Brand/Division',
        'GL Account',
        'GL Account Description',
        'Actual',
        'Accrual',
        'YTD Landing'
      ],
      columnActive: [],
      isSelectedAll: true,
      itemEdited: {
        dept: '',
        entity_name: '',
        brand_division: '',
        cost_element: null,
        ar1_commitment_po: null,
        ar1_total_spending: null,
        ar1_actual: null
      },
      colspanTotal: 6
    };
  },
  computed: {
    itemFull() {
      return this.itemsTable;
    }
  },
  watch: {
    itemsTable(val) {
      this.itemsTamp = val;
    },
    columnActive(val) {
      localStorage.setItem('columnActiveConsolidateIO', JSON.stringify(val));
      if (val.length !== this.columnTable.length) {
        this.isSelectedAll = false;
      } else {
        this.isSelectedAll = true;
      }
    }
    // tab() {
    //   this.checkActiveColumn();
    // }
  },
  created() {
    window.addEventListener('beforeunload', this.handleRefresh);
  },
  mounted() {
    this.getCostElement();
    this.itemsTamp = this.itemsTable;
    this.checkActiveColumn();
  },
  methods: {
    checkActiveColumn() {
      // set active column
      let column = JSON.parse(
        localStorage.getItem('columnActiveConsolidateIO')
      );
      let arrColumn = null;
      if (column) {
        arrColumn = column;
      } else {
        arrColumn = this.columnTable;
      }
      if (this.columnTable !== arrColumn) {
        this.columnActive = arrColumn;
      } else {
        this.columnActive = this.columnTable;
      }
    },
    getCostElement() {
      this.$store
        .dispatch('costElement/getAll', {
          limit: 10000
        })
        .then(data => {
          if (data.code === 200) {
            this.costElements = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    savePO(val) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to edit this data?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.saveData(val);
        }
      });
    },
    saveData(val) {
      this.progressDialogLoading = true;
      let id = val.id;
      let body = {
        dept: this.itemEdited.dept || val.dept,
        entity_name: this.itemEdited.entity_name || val.entity_name,
        brand_division: this.itemEdited.brand_division || val.brand_division,
        cost_element: this.itemEdited.cost_element
          ? this.itemEdited.cost_element.code
          : val.cost_element.code,
        cost_element_name: this.itemEdited.cost_element
          ? this.itemEdited.cost_element.desc
          : val.cost_element.desc,
        ar1_commitment_po:
          this.itemEdited.ar1_commitment_po || val.ar1_commitment_po,
        ar1_total_spending:
          this.itemEdited.ar1_total_spending || val.ar1_total_spending,
        ar1_actual: this.itemEdited.ar1_actual || val.ar1_actual
      };
      this.$store
        .dispatch('monthlyReport/editIO', { id: id, params: body })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: `${data.message.text_en}`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.refresh();
                this.reset();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    cancelPO(val, column) {
      this.itemEdited[column] = val[column];
    },
    editItem(val, variable) {
      this.itemEdited[variable] = val;
    },
    selectAllColumn() {
      if (this.isSelectedAll) {
        this.isSelectedAll = false;
        this.columnActive = [];
      } else {
        this.isSelectedAll = true;
        this.columnActive = this.columnTable;
      }
    },
    checkColspan() {
      let promo = [
        'Department',
        'IO Description',
        'Entity',
        'Brand/Division',
        'GL Account',
        'GL Account Description'
      ];
      let columnPromo = [];
      for (let i = 0; i < promo.length; i++) {
        if (this.columnActive.includes(promo[i])) {
          columnPromo.push(promo[i]);
        }
      }
      this.colspanTotal = columnPromo.length;
      return columnPromo.length;
    },
    checkColspan2() {
      let ar1 = ['Actual', 'Accrual', 'YTD Landing'];
      let columnAr1 = [];
      for (let j = 0; j < ar1.length; j++) {
        if (this.columnActive.includes(ar1[j])) {
          columnAr1.push(ar1[j]);
        }
      }
      return columnAr1.length;
    },
    handleRefresh() {
      localStorage.setItem(
        'columnActiveConsolidateIO',
        JSON.stringify(this.columnTable)
      );
      this.isSelectedAll = true;
    },
    refresh() {
      this.$emit('getData');
    },
    getAscSort(obj) {
      this.itemsTamp.sort(this.dynamicSort(obj.fieldName));
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.itemsTamp);
    },
    searchCln(obj) {
      let nameField = obj.fieldName;
      let arr = this.itemFull;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        this.itemsTamp = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(a[nameField].toString());
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          this.itemsTamp = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        }
      }
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        let dataFiltered = this.itemFull.reduce((result, arr) => {
          result[arr[name]] = [...(result[arr[name]] || []), arr];
          return result;
        }, {});
        return Object.keys(dataFiltered);
      } else {
        let nameField = name.split('.');
        let dataFiltered = [];
        if (nameField.length === 2) {
          dataFiltered = this.itemFull.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {});
        }
        return Object.keys(dataFiltered);
      }
    },
    reset() {
      this.itemEdited = {
        dept: '',
        entity_name: '',
        brand_division: '',
        cost_element: null,
        ar1_commitment_po: 0,
        ar1_total_spending: 0,
        ar1_actual: 0
      };
    }
  }
};
</script>

<style scoped>
.drawer-menu--scroll-consolidatePO {
  max-height: 425px;
  overflow: auto;
}
.table-po table {
  display: block;
  border-radius: 5px;
}
.table-po table th,
.table-po table td {
  white-space: nowrap !important;
  height: 30px !important;
}

.table-po table th {
  text-align: center !important;
  font-weight: 500 !important;
  background: #28a0f6;
}
/* width */
.table-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-po td {
  height: 30px !important;
  border-right: 0.1px solid rgba(0, 0, 0, 0.12);
  border-left: 0.1px solid rgba(0, 0, 0, 0.12);
}
td:hover {
  background-color: #f5f5f5 !important;
}
.menuColumn {
  max-height: 250px;
}
.v-menu__content {
  background: #fff !important;
}
</style>
